// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Dnt-","send":"styles_send__1slmh"};